var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateOrdersAnywhere(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m27.819 421.407 456.361-21.027v-316.25c0-11.491-9.373-20.865-20.865-20.865h-414.63c-11.493 0-20.866 9.373-20.866 20.865z",
    fill: "#1980f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.819 91.265h400.361v258.943h-400.361z",
    fill: "#e6f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.006 378.208h477.986c3.309-.002 6.007 2.695 6.007 6.002v34.525c0 16.5-13.499 30-29.999 30h-430c-16.5 0-29.999-13.5-29.999-30v-34.525c-.001-3.307 2.698-6.004 6.005-6.002z",
    fill: "#555e6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.45 378.208v27.227c0 3.306 2.696 6.002 6.002 6.002h145.097c3.306 0 6.002-2.696 6.002-6.002v-27.225z",
    fill: "#292e33"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m209.511 151.305h140.438c7.379 0 12.124 7.696 9.061 14.237l-24.083 61.42c-7.601 19.439-24.632 22.826-43.075 22.826h-63.425v3.428c0 1.633 1.372 3.005 3.005 3.005h94.743c5.522 0 10 4.478 10 10s-4.478 10-10 10h-94.743c-12.672 0-23.005-10.333-23.005-23.005v-12.505c-7.31-32.726-14.017-65.556-21.279-98.286h-25.096c-5.523 0-10-4.477-10-10 0-5.522 4.477-10 10-10l33.074.038c4.575-.005 8.699 3.163 9.726 7.813 1.818 8.136 3.343 15.022 4.659 21.029zm88.614 132.741c6.903 0 12.5 5.598 12.5 12.5 0 6.904-5.597 12.5-12.5 12.5s-12.5-5.596-12.5-12.5c0-6.902 5.596-12.5 12.5-12.5zm-56.614 0c6.904 0 12.5 5.598 12.5 12.5 0 6.904-5.596 12.5-12.5 12.5-6.903 0-12.499-5.596-12.499-12.5 0-6.902 5.596-12.5 12.499-12.5z",
    fill: "#4d5c7d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateOrdersAnywhere);
export default __webpack_public_path__ + "static/media/create-orders-anywhere.b6666681915d85bd5c33673a42ce20f7.svg";
export { ForwardRef as ReactComponent };